import React from 'react';
import { Upload, X, Image as ImageIcon } from 'lucide-react';

interface ImageUploadProps {
  label: string;
  image?: string;
  onUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemove?: () => void;
  isBanner?: boolean;
  /** Show the whole image (e.g. a logo) instead of cropping it to fill. */
  contain?: boolean;
  disabled?: boolean;
}

export default function ImageUpload({ label, image, onUpload, onRemove, isBanner = false, contain = false, disabled = false }: ImageUploadProps) {
  const aspectRatio = isBanner ? 'aspect-[3/1]' : 'aspect-square';

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-ink">{label}</label>
      <div className={`relative ${aspectRatio} w-full rounded-xl border-2 border-dashed border-line-strong overflow-hidden bg-raised`}>
        {image ? (
          <>
            <img src={image} alt={label} className={`w-full h-full ${contain ? 'object-contain p-3' : 'object-cover'}`} />
            {!disabled && onRemove && (
              <button
                type="button"
                onClick={onRemove}
                className="absolute top-2 right-2 p-1.5 rounded-full bg-black/50 text-white hover:bg-black/70 transition-colors"
              >
                <X className="w-4 h-4" />
              </button>
            )}
          </>
        ) : (
          <label className={`flex flex-col items-center justify-center w-full h-full cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-raised'}`}>
            <input
              type="file"
              accept="image/*"
              onChange={onUpload}
              disabled={disabled}
              className="hidden"
            />
            <ImageIcon className="w-8 h-8 text-ink-faint mb-2" />
            <span className="text-sm text-ink-muted">Upload image</span>
          </label>
        )}
      </div>
    </div>
  );
}
